'use client';

import Phone from '@hc-frontend/core-icons/kit/phone';

export function AnimatedPhoneIcon() {
  return (
    <span className="relative before:content-[''] before:bg-gray-0 before:absolute before:rounded-full before:animate-pulse-circle before:inset-0 after:content-[''] after:bg-gray-0 after:absolute after:rounded-full after:animate-pulse-circle after:inset-0 after:delay-100">
      <Phone
        aria-label="animated phone icon"
        width={24}
        height={24}
        className="animate-phone-ring"
      />
    </span>
  );
}
